export default "__VITE_ASSET__62fc6f72__"